<template>
  <div class="layout-mobile">
    <asta-drawer-standalone v-if="Config.STANDALONE"></asta-drawer-standalone>
    <asta-drawer v-else></asta-drawer>
    <asta-nav></asta-nav>
    <v-main>
      <!-- svincolati -->
      <v-dialog
        eager
        max-width="450"
        v-model="svincolatiDrawer"
        content-class="asta-svincolati-mobile-dialog"
      >
        <v-card>
          <v-card-title class="secondary white--text">
            <span class="font-hemi-head">SVINCOLATI</span>

            <v-spacer></v-spacer>
            <v-btn icon @click="toggleSvincolati">
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </v-card-title>
          <asta-svincolati class="navy darken-1"></asta-svincolati>
        </v-card>
      </v-dialog>
      <!-- tavolo  -->
      <div class="asta-tavolo-mobile">
        <asta-tavolo></asta-tavolo>
      </div>
      <!-- chat  -->
      <div class="asta-chat-messages-mobile">
        <asta-chat-messages></asta-chat-messages>
      </div>
      <!-- rose -->
      <!-- <v-navigation-drawer
        v-model="roseOrPlanDrawer"
        absolute
        class="asta-rose-mobile"
        temporary
        right
        v-if="false"
      >
        <asta-rose scuro></asta-rose>
      </v-navigation-drawer> -->
      <v-dialog
        eager
        persistent
        max-width="450"
        v-model="roseOrPlanDrawer"
        content-class="asta-rose-mobile-dialog"
      >
        <v-card>
          <v-card-title class="secondary white--text">
            <span class="font-hemi-head" v-if="planOrRose == 'plan'"
              >PIANIFICAZIONE</span
            >
            <span class="font-hemi-head" v-if="planOrRose == 'rose'">ROSE</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="toggleRose">
              <v-icon class="white--text">close</v-icon>
            </v-btn>
          </v-card-title>
          <asta-rose
            showTitle
            class="navy darken-1"
            v-show="planOrRose == 'rose'"
          ></asta-rose>
          <asta-plan
            v-if="my_squadra"
            class="navy darken-1"
            v-show="planOrRose == 'plan'"
          ></asta-plan>
        </v-card>
      </v-dialog>
      <!-- chat -->
      <div class="asta-chat-input-mobile">
        <asta-chat-input></asta-chat-input>
      </div>
      <!-- floating buttons -->
      <v-btn
        color="gradient-green"
        absolute
        bottom
        left
        fab
        @click="toggleSvincolati"
      >
        <div class="d-flex flex-column justify-center align-center white--text">
          <v-icon>groups </v-icon>
          <div class="text-caption">Svinc</div>
        </div>
        <!-- <v-icon class="ma-n3">chevron_left</v-icon>
        <v-icon class="ma-2">groups </v-icon> -->
      </v-btn>

      <v-btn
        color="gradient-green"
        fab
        absolute
        bottom
        right
        @click="toggleRose"
      >
        <div class="d-flex flex-column justify-center align-center white--text">
          <!-- <v-icon>admin_panel_settings </v-icon> -->
          <div class="text-caption">Rose /</div>
          <div class="text-caption">Pianif.</div>
        </div>
        <!-- <v-icon class="ma-2">admin_panel_settings </v-icon> -->
        <!-- <v-icon class="ma-n3">navigate_next</v-icon> -->
      </v-btn>
    </v-main>
    <!-- footer -->
    <asta-footer fixed paddedTop></asta-footer>
  </div>
</template>

<script>
// import Config from "../../../config-app/config";
import AstaNav from "../AstaNav.vue";
import AstaTavolo from "../AstaTavolo.vue";
import AstaDrawer from "../AstaDrawer";
import AstaDrawerStandalone from "../AstaDrawerStandalone";
import AstaSvincolati from "../AstaSvincolati";
import AstaRose from "../AstaRose";
import AstaChatMessages from "../AstaChatMessages";
import AstaChatInput from "../AstaChatInput";
import AstaPlan from "../AstaPlan";
import Vuex from "vuex";
import mixins from "../../js/mixins";
import Constants from "../../js/constants";
import db from "../../js/db";
import AstaFooter from "../AstaFooter";

export default {
  name: "asta-mobile",
  mixins: [mixins],
  components: {
    AstaNav,
    AstaTavolo,
    AstaSvincolati,
    AstaRose,
    AstaChatMessages,
    AstaChatInput,
    AstaPlan,
    AstaDrawer,
    AstaDrawerStandalone,
    AstaFooter,
  },
  data() {
    return {
      // value: Constants.ASTA_TABS.MAIN,
      drawer: true,
      svincolatiDrawer: false,
      roseOrPlanDrawer: false,
      // Config: Config
    };
  },

  methods: {
    toggleSvincolati() {
      this.svincolatiDrawer = !this.svincolatiDrawer;
    },
    toggleRose() {
      this.roseOrPlanDrawer = !this.roseOrPlanDrawer;
    },
    showRoseOrPlan() {
      this.roseOrPlanDrawer = true;
    },
  },
  mounted() {
    console.log("--> AstaMobile ready.");
    db.on("showRoseOrPlan", this.showRoseOrPlan);
  },
  destroyed() {
    console.log("<-- AstaMobile destroyed.");
    db.off("showRoseOrPlan", this.showRoseOrPlan);
  },
  computed: {
    ...Vuex.mapGetters(["planOrRose"]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.asta-tavolo-mobile {
  position: absolute;
  right: 0;
  top: 0px;
  left: 0;
  // bottom: 70%;
}
.asta-chat-messages-mobile {
  position: absolute;
  top: 15%; // serve per evitare che l'user tenti di scrollare sui messaggi che nn scrollerebbero
  bottom: 0px;
  left: 0;
  right: 0;
  .chat {
    padding-bottom: 35px;
  }
}
.asta-chat-input-mobile {
  position: absolute;
  bottom: -23px;
  left: 0;
  right: 0;
}
.asta-svincolati-mobile {
  max-width: 400px !important;
  width: 90% !important;
  .svincolati {
    margin-top: 25px;
    margin-bottom: 40px;
  }
}
.asta-rose-mobile {
  max-width: 400px !important;
  width: 90% !important;
  transform: none !important; // senza questa linea il layout sballa su se su dev-tools clcci sull'iconcina "toggle device toolbar"
}

.v-main {
  height: 100vh;
  // background-image: url(/static/img/bg-seamless.png);
  // background-repeat: repeat;
  // background-color: white;
  background-color: var(--v-navy-darken1);
  background-image: linear-gradient(
    0deg,
    var(--v-navy-darken2),
    var(--v-navy-darken1) 300px
  );
}

/* .v-bottom-navigation .v-btn--active {
  border-bottom: 5px solid var(--v-primary-darken2);
} */
</style>
